<script setup>
import {
  onMounted, ref, defineProps, defineEmits,
} from 'vue';

const props = defineProps({
  reviewData: {
    type: Object,
  },
});
const emit = defineEmits(['changeStep', 'changeData']);
const starHover = ref(-1); // 0 - 4
const star = ref(-1);
const content = ref('');
const saveData = () => {
  emit('changeData', {
    rating: star.value,
    content: content.value,
  });
  emit('changeStep', 2);
};

function updateCoordinates(event) {
  starHover.value = Number(event.target.dataset.index)
    + Number((event.offsetX / 35).toFixed(1));
}
onMounted(() => {
  star.value = props.reviewData.rating;
  content.value = props.reviewData.content;
});

// 評價內容驗證
const commentValidate = () => {
  const tempComment = content.value;
  content.value = tempComment.replace(/[^a-zA-Z0-9\u4e00-\u9fa5\\_\\-\\.?!\\r\\n,.，！。？、 \n]/g, '');
  if (content.value.length > 200) {
    content.value = content.value.slice(0, 200);
  }
};
</script>

<template>
  <div class="modal-body">
    <div class="mt-4 mb-2">
      <h4 class="text-center mb-3">
        <div class="d-inline-flex align-items-center">
          講師們邀請您替這門課程留下評價
          <span class="material-icons-outlined align-middle ms-1"> mood </span>
        </div>
      </h4>
      <h5 class="text-center">您對於此課程的評價如何？</h5>
      <div
        class="d-flex justify-content-center my-2"
        @mouseleave="starHover = -1"
      >
        <a
          href="#"
          class="starIcon"
          v-for="n in 5"
          :key="`star${n}`"
          @click.prevent="star = starHover"
          @mousemove="updateCoordinates"
          :data-index="n"
        >
          <span
            v-if="starHover < n && star < n"
            :data-index="n"
            style="font-size: 35px"
            class="material-icons-outlined align-middle ms-1"
          >
            grade
          </span>
          <span
            v-else
            :data-index="n"
            style="font-size: 35px"
            class="material-icons-outlined align-middle ms-1"
          >
            star
          </span>
        </a>
      </div>
      <div class="mt-4 mb-2">
        <p class="fw-bold mb-0">寫下您對這門課程的學習心得吧！</p>
        <small class="text-muted"
          >僅能輸入數字、英文、中文字、標點符號（逗號、句號、驚嘆號、問號、頓號）</small
        >
        <div class="d-flex justify-content-end">
          <small class="text-muted"
            >{{ 200 - (content?.length || 0) }} / 200</small
          >
        </div>
        <textarea
          class="form-control mt-2"
          placeholder="這門課程對我來說很棒！"
          id=""
          rows="6"
          v-model="content"
          @keyup="commentValidate"
        ></textarea>
      </div>
      <div class="d-flex justify-content-between flex-wrap">
        <p class="fw-bold">評價將會公開於課程平台，幫助想上這門課程的同學！</p>
        <button
          type="button"
          class="btn btn-hex-review-dark"
          @click="saveData"
          :disabled="!star || star < 0"
        >
          儲存並繼續
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.starIcon{
   color: #5dba83;
}
.starIcon:hover, .starIcon:focus, .starIcon:active {
  color: #4a9569;
}
</style>
